"use client";
import * as React from "react";
const SvgTuneFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 12.44v1.78h5.33v-1.78zM0 1.78v1.78h8.89V1.78zM8.89 16v-1.78H16v-1.78H8.89v-1.77H7.1V16zM3.56 5.33v1.78H0V8.9h3.56v1.78h1.77V5.33zM16 8.9V7.11H7.11v1.78zm-5.33-3.56h1.77V3.56H16V1.78h-3.56V0h-1.77z" }));
export {
  SvgTuneFilled as default
};
